import { Box, Typography } from '@mui/material'
import React, { useEffect, useRef } from 'react'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

interface Props {
  tag?: React.ElementType
  children: string | React.ReactNode
  sx?: {} | React.CSSProperties
}

const Title: React.FC<Props> = ({ tag = 'div', children, sx }) => {
  const titleRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (titleRef.current) {
      gsap.fromTo(
        titleRef.current,
        { opacity: 0, y: 60 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: titleRef.current,
            start: 'top 80%',
            toggleActions: 'play none none reverse',
          },
        }
      )
    }
  }, [])

  return (
    <Box sx={{ textAlign: 'center' }} ref={titleRef}>
      <Typography
        sx={{
          position: 'relative',
          display: 'inline-block',
          color: '#454545',
          fontFamily: "'Proxima Nova', sans-serif",
          fontSize: { xs: '2.5rem', sm: '3.5rem' },
          fontStyle: 'normal',
          fontWeight: 600,
          lineHeight: 1.2,
          '&::before': {
            position: 'absolute',
            content: "''",
            bottom: '-10px',
            left: '-5%',
            width: '110%',
            height: '8px',
            backgroundColor: '#4caf50',
            borderRadius: '3px',
          },
        }}
        component={tag}
      >
        {children}
      </Typography>
    </Box>
  )
}

export default Title
